export default "__VITE_ASSET__cfff0cab__"